import React from 'react';

import { useStyleSwitch } from '../../../hooks/useStyleSwitch';
import { BodyText } from '../../Text';
import type { ChipState, ChipTextProps } from '../Chip.types';
import { textStyles as textStylesConfig } from '../styles';

export const ChipText = ({
  state,
  children,
  maxFontSizeMultiplier,
}: ChipTextProps) => {
  const useTextStyles = useStyleSwitch<ChipState>('state', textStylesConfig);
  const textStyles = useTextStyles(state);

  return (
    <BodyText
      size={4}
      style={textStyles}
      maxFontSizeMultiplier={maxFontSizeMultiplier}
    >
      {children}
    </BodyText>
  );
};
